import React from 'react';

export default {
  svg: (
    <g>
      <path
        d="M240.6,258.4H56c-6.9,0-12.5-5.6-12.5-12.5V54.1c0-6.9,5.6-12.5,12.5-12.5h184.6c6.9,0,12.5,5.6,12.5,12.5
        v191.8C253.1,252.8,247.5,258.4,240.6,258.4L240.6,258.4z M58.5,243.4h179.6V56.6H58.5L58.5,243.4z M228.4,85.1h-99.5v15h99.4
        L228.4,85.1z M216.5,106.1h-87.6v15h87.6L216.5,106.1z M195.9,127.1h-67v15h67V127.1z M93.9,90.9c-12.6,0-22.7,10.2-22.7,22.7
        s10.2,22.7,22.7,22.7s22.7-10.2,22.7-22.7l0,0C116.7,101.1,106.5,90.9,93.9,90.9C93.9,90.9,93.9,90.9,93.9,90.9L93.9,90.9z
         M212.4,234.1h-128c-6.9,0-12.5-5.6-12.5-12.5v-46.7c0-6.9,5.6-12.5,12.5-12.5l0,0h128c6.9,0,12.5,5.6,12.5,12.5v46.7
        C224.8,228.5,219.3,234.1,212.4,234.1z M86.9,219.1h123v-41.7h-123V219.1z"
        fillRule="evenodd"
      />
    </g>
  ),
  viewBox: '0 0 300 300'
};
